
























import { Component, Mixins, } from "vue-property-decorator";
import { FormatTreeSource, ITreeSource } from "../../applications/formatEditor/components/format/selectors/trees/sources";
import EditableFormatSummariesTreeSelector from "../../applications/formatEditor/components/format/selectors/trees/EditableFormatSummariesTreeSelector.vue";
import { IEditableFormatSummaryTreeNode, EditableFormatSummary } from "../../applications/formatEditor/domain/editableFormat";
import { IEmbeddedFolderSelectionResult } from "../../domain/document";
import { FormatReference } from "../../domain/format";
import { Directory } from "../../domain/drawing";

@Component({
  components: {
    selector: EditableFormatSummariesTreeSelector,
  }
})
export default class EmbeddedEditableFormatSummariesTreeSelectorView extends Mixins() {
  data() {
    return {
      isLoading: false,
      selectedDirectoryId: null as number,
      directories: null as Directory<string, FormatReference>[],
      treeSource: null as ITreeSource<number, EditableFormatSummary>,
    };
  }
  isLoading: boolean;
  selectedDirectoryId: number;
  directories: Directory<number, EditableFormatSummary>[];
  treeSource: ITreeSource<number, EditableFormatSummary>;

  async mounted(): Promise<void> {
    this.treeSource = new FormatTreeSource();
    await this.load();
  }

  get isSelected(): boolean {
    return !!this.selectedDirectoryId;
  }

  async load(): Promise<void> {
    try {
      this.isLoading = true;
      await this.loadTree();
    } finally {
      this.isLoading = false;
    }
  }

  async loadTree(): Promise<void> {
    try {
      this.directories = await this.treeSource.getTree();
    } catch (e) {
      this.directories = [];
      const entityName = this.treeSource.entityName;
      this.$error(entityName + "取得失敗", entityName + "を読み込めませんでした。", e);
    }
  }

  treeNodeSelected(value: IEditableFormatSummaryTreeNode): void {
    this.selectedDirectoryId = ((value.data.source instanceof Directory) && !!value) ? value.data.source.key : null;
  }

  select(): void {
    this.notifyMessage(this.createResultMessage(true, this.selectedDirectoryId));
  }

  cancel(): void {
    this.notifyMessage(this.createResultMessage(false, null as number));
  }

  createResultMessage(isSelected: boolean, directoryId: number): IEmbeddedFolderSelectionResult {
    return {
      request: "notify-folder-selected",
      isSelected: isSelected,
      directoryId: directoryId,
    };
  }

  notifyMessage(result: IEmbeddedFolderSelectionResult): void {
    try {
      if (window.parent) {
        window.parent.postMessage(JSON.stringify(result), "*");
      }
    } catch (e) {
      console.log(e);
    }
  }
}
